import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-min-fund-box',
  templateUrl: './min-fund-box.component.html',
  styleUrls: ['./min-fund-box.component.scss'],
  standalone: false
})
export class MinFundBoxComponent {
  @Input() minFundingAmount: number;
  @Input() currency: string;
  @Input() language: string;

  constructor(
    private trackingService: TrackingService,
    private router: Router
  ) {}

  onShowAccountDetails(): void {
    this.trackingService.trackActivity('Saving Plan Widget CTA');
    void this.router.navigate(['/adjust-investment'], { queryParams: { accountDetails: true }, skipLocationChange: true });
  }
}
